module.exports = __webpack_public_path__ + "static/media/brackets.366e94fc.png";